module.exports = __webpack_public_path__ + "static/sav.banner-mosaic-fio-de-cristal-facetado-46049824387f5346f446ce46264d0ff0.jpg";